/* import __COLOCATED_TEMPLATE__ from './if-block.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();